<template>
  <div class="wallet-modal" @keydown.esc="secondaryBtnAction" ref="walletModal">
    <div class="wallet-modal__container">
      <p class="small-headline">{{ $t('WalletModal.label.continue') }}</p>

      <h1 class="extra-large-headline">{{ $t('WalletModal.label.continue') }}</h1>

      <p class="bodycopy">
        {{ $t('WalletModal.label.body') }}
      </p>

      <span class="wallet-modal__address extra-large-headline">
        {{ userWalletAddress }}
      </span>

      <p class="wallet-modal__faq">
        {{ $t('WalletModal.label.ask') }}
        <br />
        <a
          ref="noreferrer noopner"
          target="_blank"
          href="https://support.banxa.com/en/support/solutions/articles/44002269747-wallet-overview"
        >
          {{ $t('WalletModal.label.faqs') }}
        </a>
      </p>

      <ButtonBase @click="secondaryBtnAction" outlined>
        {{ $t('ButtonBase.label.editWalletAddress') }}
      </ButtonBase>
      <ButtonBase @click="primaryBtnAction">
        {{ $t('ButtonBase.label.continueVerification') }}
      </ButtonBase>
    </div>
  </div>
</template>
<script setup>
import { onMounted, computed, ref } from "vue";
import gsap from "gsap";
import { obfuscateWithMiddleEllipsis } from "@/composables/helpers/useStringHelpers";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import { useBuyOrderFormStore } from "@/stores/forms/buyOrderFormStore";

const props = defineProps({
  modalOptions: {
    type: Object,
    required: false,
    default: () => ({
      title: "",
      text: "",
      primaryBtnText: $t('WalletModal.label.gotIt'),
      secondaryBtnText: "",
      alignment: {}, // used in BaseModal
    }),
  },
});
const $emit = defineEmits(["onPrimaryButtonClick", "onSecondaryButtonClick"]);
const walletModal = ref(null);
const store = useBuyOrderFormStore();

const userWalletAddress = computed(() =>
  obfuscateWithMiddleEllipsis(store.getFormPayload.walletAddress, 22)
);

const primaryBtnAction = () => {
  if (props.modalOptions.primaryBtnAction) {
    props.modalOptions.primaryBtnAction();
  }

  return $emit("onPrimaryButtonClick");
};

const secondaryBtnAction = () => {
  if (props.modalOptions.secondaryBtnAction) {
    props.modalOptions.secondaryBtnAction();
  }

  return $emit("onSecondaryButtonClick");
};

onMounted(() => {
  walletModal.value.focus();

  const successTl = gsap.timeline();
  successTl.fromTo(
    ".wallet-modal",
    {
      duration: 0.75,
      y: 30,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      delay: 0.5,
      ease: "inOut.power3",
    }
  );
});
</script>
<style lang="scss" scoped>
.wallet-modal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  background: var(--modal-content-background);
  border-radius: $border-radius $border-radius 0 0;

  @include breakpoint($min-m) {
    border-radius: $border-radius;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 1.5rem 3rem;

    @include breakpoint($min-m) {
      padding: 3rem;
      max-width: 468px;
    }

    .bodycopy {
      margin-bottom: 1.8rem;
    }

    .button {
      margin-bottom: 1rem;
    }

    .small-headline {
      color: var(--primary);
      margin-bottom: 1.8rem;
    }
  }

  &__address {
    padding: 1.5rem 3rem;
    color: var(--toggle-text-color-second);
    background: var(--input-background);
    border-radius: 1.6rem;
    text-align: center;
  }

  &__faq {
    text-align: center;
    margin-bottom: 2rem;
    a {
      text-decoration: none;
    }
  }
}
</style>
